/**
 * Contact-details panel copy for the RFQ section, TR / EN / DE.
 * Lifted VERBATIM from the contact sections of App.jsx, AppEN.jsx and AppDE.jsx.
 * `hours` / `hoursValue` restate the openingHoursSpecification already published
 * in index.html's LocalBusiness JSON-LD (Mon–Fri 08:00–18:00).
 */

export const MAPS_URL =
  'https://www.google.com/maps/search/?api=1&query=küçükbalıklı+mahallesi+2.ordulusokak+no+83+16250+Osmangazi/Bursa'
export const PHONE_DISPLAY = '+90 224 999 91 12'
export const PHONE_HREF = 'tel:+902249999112'
export const EMAIL = 'info@ankaplastik.com'

export const RFQ_I18N = {
  tr: {
    infoTitle: 'İletişim Bilgileri',
    infoLead: 'Sorularınız için bize ulaşabilirsiniz.',
    address: 'Adres',
    addressLines: ['Küçükbalıklı Mah. 2. Ordulu Sok. No:83', 'Osmangazi / Bursa'],
    phone: 'Telefon',
    email: 'E-posta',
    hours: 'Çalışma saatleri',
    hoursValue: 'Pazartesi – Cuma, 08:00 – 18:00',
  },
  en: {
    infoTitle: 'Contact Information',
    infoLead: 'Reach out to us with your inquiries.',
    address: 'Address',
    addressLines: ['Küçükbalıklı Mah. 2. Ordulu Sok. No:83', 'Osmangazi / Bursa, Türkiye'],
    phone: 'Phone',
    email: 'Email',
    hours: 'Opening hours',
    hoursValue: 'Monday – Friday, 08:00 – 18:00',
  },
  de: {
    infoTitle: 'Kontaktinformationen',
    infoLead: 'Kontaktieren Sie uns bei Fragen.',
    address: 'Adresse',
    addressLines: ['Küçükbalıklı Mah. 2. Ordulu Sok. No:83', 'Osmangazi / Bursa, Türkiye'],
    phone: 'Telefon',
    email: 'E-Mail',
    hours: 'Öffnungszeiten',
    hoursValue: 'Montag – Freitag, 08:00 – 18:00',
  },
}
